/**
 * Created by tofael on 10/9/17.
 */

import 'whatwg-fetch';
import React from 'react';
import {connect} from 'react-redux';
import {hashHistory} from 'react-router';

import api from '../utility/api';
import DoctorForm from '../screens/create-doctor';
import {asyncStart, asyncEnd, showFeedback} from '../actions/application';

class CreateDoctor extends React.Component {

  constructor() {
    super(...arguments);
    this.state = {
      name: '',
      email: '',
      phone: '',
      photo: null,
      doc_reg_no: '',
      passed_from: '',
      doctor_fee: {
        physical: undefined,
        remote: undefined
      },
      doctor_fee_within_week: {
        physical: undefined,
        remote: undefined
      },
      doctor_fee_within_month: {
        physical: undefined,
        remote: undefined
      },
      passing_year: null,
      provider: false,
      operator: false,
      status: 'approved',
      credentials:'MBBS',
      speciality: '',
      current_address_street: '',
      current_address_area: '',
      current_address_postcode: '',
      permanent_address_street: '',
      permanent_address_area: '',
      permanent_address_postcode: '',
      current_engagement: '',
      current_engagement_institute: '',
      available_specialities: []
    };
  }

  displayFeedBack(message){
    this.props.dispatch(showFeedback({message: message}));
  }

  dispatch(action){
    this.props.dispatch(action());
  }

  componentDidMount() {
    this.getAvailableSpecialities();
  }

  getAvailableSpecialities() {
    api.getSpecialities()
    .then((data) => {
      this.setState({available_specialities: data})
    })
  }

  handleSubmit(e) {

    e.preventDefault();

    let {provider, operator} = this.state;

    if( !provider && !operator){
      this.displayFeedBack('Please select a role.');
      return;
    }

    let doctorInfo = {};
    Object.assign(doctorInfo, this.state);
    delete doctorInfo.photo;
    delete doctorInfo.available_specialities;

    this.props.dispatch(asyncStart());
    api.createDoctor(doctorInfo)
      .then(doctor => {
        if (this.state.photo) {
          let form_data = new FormData();
          form_data.append('photo', this.state.photo);
          form_data.append('id', doctor.id);

          return api.updateDoctorPhoto(form_data);
        }
        return doctor;
      })
      .then(doctor=>{
        this.dispatch(asyncEnd);
        hashHistory.push('doctor/' + doctor.id);
      })
      .catch(error => {
        this.dispatch(asyncEnd);
        this.displayFeedBack(error.message);
      })

  }

  handleChange(field, e) {
    if(field === 'physical' || field === 'remote') {
     this.setState({
       doctor_fee:{
         ...this.state.doctor_fee,
         [field]: e.target.value
       }
     })
    } 
    else if(field === 'physical_within_week') {
      this.setState({
        doctor_fee_within_week:{
          ...this.state.doctor_fee_within_week,
          physical: e.target.value
        }
      })
     }
     else if(field === 'remote_within_week') {
      this.setState({
        doctor_fee_within_week:{
          ...this.state.doctor_fee_within_week,
          remote: e.target.value
        }
      })
     }
     else if(field === 'physical_within_month') {
      this.setState({
        doctor_fee_within_month:{
          ...this.state.doctor_fee_within_month,
          physical:e.target.value
        }
      })
     }
     else if(field === 'remote_within_month') {
      this.setState({
        doctor_fee_within_month:{
          ...this.state.doctor_fee_within_month,
          remote: e.target.value
        }
      })
     } else {
    this.setState({[field]: e.target.value});
  }
  }

  onCheck(field, e, value) {
    this.setState({[field]: value});
  }

  onPhotoSelect(e) {
    let file = e.target.files[0];
    this.setState({photo: file});
  }

  onSelectSpeciality(_, __, speciality) {
    this.setState({speciality});
  }

  render() {
    return (
      <DoctorForm
        state={this.state}
        available_specialities={this.state.available_specialities}
        onCheck={this.onCheck.bind(this)}
        handleChange={this.handleChange.bind(this)}
        handleSubmit={this.handleSubmit.bind(this)}
        onPhotoSelect={this.onPhotoSelect.bind(this)}
        onSelectSpeciality={this.onSelectSpeciality.bind(this)}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(CreateDoctor);



// WEBPACK FOOTER //
// ./src/containers/create-doctor.js